import {
    GET_SALES_TAX_REQUEST,
    GET_SALES_TAX_SUCCESS,
    GET_SALES_TAX_FAILURE
  } from "./salestaxType";
  
  const initialSalesTaxState = {
    loading: false,
    salestax: [],
    error: "",
  };
  
  const salesTaxReducer = (state = initialSalesTaxState, action) => {
    switch (action.type) {
      case GET_SALES_TAX_REQUEST:
        return {
          ...state,
          loading: true,
        };
      case GET_SALES_TAX_SUCCESS:
        return {
          ...state,
          loading: false,
          salestax: action.payload,
          error: "",
        };
      case GET_SALES_TAX_FAILURE:
        return {
          ...state,
          loading: false,
          salestax: [],
          error: action.payload,
        };
      default:
        return state;
    }
  };
  export default salesTaxReducer;
  